const LatestNewsScreen = () => {


    return (
       <p>Latest News here</p>
    )
}

export default LatestNewsScreen